import { useContext } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiGet, apiPatch, apiPatchFormData } from 'api';
import AuthContext from 'context/auth-context';

const getMunicipalitySetting = async (token, municipalityId) => {
  const url = `admin/municipalities/${municipalityId}/setting`;
  const data = await apiGet({ url, token });
  return data;
};

const updateMunicipalitySetting = async (token, municipalityId, params) => {
  const url = `admin/municipalities/${municipalityId}/setting`;
  const data = await apiPatch({ url, token, objectName: 'municipality_setting', params });
  return data;
};

export function useAdminMunicipalitySetting({ municipalityId, options } = {}) {
  const token = useContext(AuthContext);
  const queryFn = () => getMunicipalitySetting(token, municipalityId);
  const queryKey = ['admin-municipality-setting', municipalityId];
  return useQuery(queryKey, queryFn, { enabled: !!municipalityId, ...options });
}

export function useUploadAdminMunicipalityLogo({ municipalityId, options } = {}) {
  const token = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation(
    (file) => apiPatchFormData({
      url: `admin/municipalities/${municipalityId}/setting`,
      token,
      objectName: 'municipality_setting',
      params: { logo: file }
    }),
    {
      ...options,
      onSuccess: (data) => {
        queryClient.invalidateQueries(['admin-municipality-setting', municipalityId]);
        if (options?.onSuccess) {
          options.onSuccess(data);
        }
      }
    }
  );
}

export function useUpdateAdminMunicipalitySetting({ municipalityId, options } = {}) {
  const token = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation(
    (params) => updateMunicipalitySetting(token, municipalityId, params),
    {
      ...options,
      onSuccess: (data) => {
        queryClient.invalidateQueries(['admin-municipality-setting', municipalityId]);
        queryClient.invalidateQueries(['admin-municipality', municipalityId]);
        if (options?.onSuccess) {
          options.onSuccess(data);
        }
      }
    }
  );
}
